export default function TopText(props) {
    return (
        <input type="text" name="topText" onChange={props.handleChange} className="top-text" placeholder="top of meme"></input>
    )
}